import { gameState } from 'appworks/model/game-state';
import { Services } from 'appworks/services/services';
import { ValueList } from 'appworks/utils/value-list';
import { ClientController } from 'client-controller';
import { SlingoGameProgressResult } from 'slingo/model/results/slingo-game-progress-result';
import { slingoModel } from 'slingo/model/slingo-model';
import { SlingoIdleState } from 'slingo/states/slingo-idle-state';
import { SlotBetService } from 'slotworks/services/bet/slot-bet-service';

export class SocialIdleState extends SlingoIdleState {
  public onEnter(): void {
    super.onEnter();
    this.handleBets();
  }

  /**
   * Inject bet stakes into model
   *
   * @private
   */
  private handleBets(): void {
    // Get the current game's stake if already in progress
    const progressData = gameState.getCurrentGame().getLatestResultOfType(SlingoGameProgressResult);
    const inProgressStake = progressData?.standardStake

    // Save the real config
    const gmrStakeConfig = slingoModel.read().stakeConfig;
    const gmrDefaultStake = gmrStakeConfig.amounts[gmrStakeConfig.defaultIndex];

    // Change the list of stakes to ours
    const model1 = slingoModel.read();
    model1.stakeConfig.amounts = ClientController.getInstance().betStakes.map(stake => stake * 100);
    slingoModel.write(model1);

    // Read what we just wrote because deepClone
    const stakeConfig = slingoModel.read().stakeConfig;

    // Find the next valid stake
    const amounts = stakeConfig.amounts;
    const defaultStake = amounts.find(stake => stake >= gmrDefaultStake) || amounts[0];
    const previousStake = inProgressStake || stakeConfig.lastStake || defaultStake;
    const newDefaultIndex = amounts.indexOf(defaultStake);

    // Convert defaultStake back to the new index
    const model2 = slingoModel.read();
    model2.stakeConfig.defaultIndex = newDefaultIndex;
    slingoModel.write(model2);

    // Save the new stake config
    Services.get(SlotBetService).setDefaults(
      new ValueList<number>(amounts, defaultStake, previousStake),
      new ValueList<number>([1], 1, 1),
    );
  }
}
